import { Dialog } from '@mui/material';
import { Box } from '@mui/system';
import { useCallback, useMemo } from 'react';
import { DebugModal } from '@/modules/debug';
import { MultiCopyModal as MultiCopyCanvasModal } from '@/modules/copy/components/MultiCopyModal';
import { SettingsModal } from '@/components/SettingsPanel';
import { ReleaseNotesModal } from './modals/ReleaseNotesModal';
import { useAppStore } from '@/modules/app/store/useAppStore';
import { AppServiceFactory } from '@/modules/app/service/AppServiceFactory';

export function ModalManager() {
  const activeModalId = useAppStore((state) => state.activeModalId);

  const closeModalCallback = useCallback(() => {
    AppServiceFactory.getInstance().createAppService().setActiveModalId(null);
  }, []);

  const currentModal = useMemo(() => {
    switch (activeModalId) {
      case 'multi_copy_canvas':
        return <MultiCopyCanvasModal closeModal={closeModalCallback} />;
      case 'release_notes':
        return <ReleaseNotesModal closeModal={closeModalCallback} />;
      case 'settings':
        return <SettingsModal closeModal={closeModalCallback} />;
      case 'debug':
        return <DebugModal />;
      default:
        return null;
    }
  }, [closeModalCallback, activeModalId]);

  if (!currentModal) {
    return null;
  }

  return (
    <Dialog
      open
      onClose={closeModalCallback}
      maxWidth={false}
      PaperProps={{ sx: { width: 'fit-content', maxWidth: 'calc(100vw - 64px)' } }}
    >
      <Box sx={{ p: 4 }}>{currentModal}</Box>
    </Dialog>
  );
}
